import i18n from "@/lang";
import Layout from "@/Layout";
export const payment = [];
import store from "../store";

export const asyncRouterMap = [
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "/dashboard",
        component: () => import("@/views/dashboard"),
        name: "dashboard",
        meta: {
          title: "dashboard",
        },
      },
    ],
  },
  {
    path: "/crm",
    component: Layout,
    redirect: "/crm",
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/crm",
        component: () => import("@/views/crm"),
        name: "crmList",
        meta: { permission: "index_api_admin-panel_crm_actions" },
      },
      {
        path: "/crm/:tab",
        component: () => import("@/views/crm/index"),
        name: "crmDetails",
        hidden: true,
        meta: { permission: "index_api_admin-panel_crm_actions" },
      },
      {
        path: "/crm/:tab/download",
        component: () => import("@/views/crm/index"),
        name: "importTasks",
        hidden: true,
        meta: { permission: "index_api_admin-panel_crm_multiple-tasks" },
      },
    ],
  },
  {
    path: "/camps",
    component: Layout,
    redirect: "/camps",
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/camps",
        component: () => import("@/views/camps"),
        name: "Camps",
        meta: {
          title: "camps",
          permission: "index_api_admin-panel_camps",
        },
      },
      {
        path: "/camps/:id/teams",
        component: () => import("@/views/camps/teams"),
        name: "CampsTeams",
        meta: {
          title: "CampsTeams",
          permission: "index_api_admin-panel_camps_{camp}_teams",
        },
      },
      {
        path: "/camps/:id/teams/age-group",
        component: () => import("@/views/camps/teams/group"),
        name: "CampsTeamsGroups",
        meta: {
          title: "CampsTeamsGroups",
          permission: "index_api_admin-panel_camps_{camp}_groups",
        },
      },
      {
        path: "/camps/:id/majors",
        component: () => import("@/views/camps/majors"),
        name: "CampsMajors",
        meta: {
          title: "camps",
          permission: "index_api_admin-panel_camps_{camp}_majors",
        },
      },
      {
        path: "/camps/create",
        component: () => import("@/views/camps/create"),
        name: "CampsCreate",
        meta: {
          title: "campsCreate",
          permission: "store_api_admin-panel_camps",
        },
      },
      {
        path: "edit/:id",
        component: () => import("@/views/camps/create"),
        name: "editCamp",
        hidden: true,
        meta: {
          title: "edit",
          permission: "update_api_admin-panel_camps_{camp}",
        },
      },
    ],
  },
  {
    path: "/reports",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/reports/daily-figures",
        component: () => import("@/views/reports/daily-figures"),
        name: "DailyFigures",
        meta: {
          permission: "index_api_admin-panel_reports_camp-statistics-per-day",
        },
      },
      {
        path: "/reports/individual",
        component: () => import("@/views/reports/individual"),
        name: "IndividualReports",
        meta: {
          permission: "index_api_admin-panel_reports_individual",
        },
      },
      {
        path: "/reports/family",
        component: () => import("@/views/reports/family"),
        name: "familyReports",
        meta: {
          permission: "index_api_admin-panel_reports_family",
        },
      },
      {
        path: "/reports/finance",
        component: () => import("@/views/reports/finance"),
        name: "financeReports",
        meta: {
          permission: "index_api_admin-panel_reports_finance",
        },
      },
      {
        path: "/reports/receipts",
        component: () => import("@/views/reports/receipts"),
        name: "receiptsReports",
        meta: {
          permission: "index_api_admin-panel_reports_receipts",
        },
      },
      {
        path: "/reports/teams",
        component: () => import("@/views/reports/teams"),
        name: "teamsReports",
        meta: {
          permission: "index_api_admin-panel_reports_teams",
        },
      },
      {
        path: "/reports/majors",
        component: () => import("@/views/reports/majors"),
        name: "majorsReports",
        meta: {
          permission: "index_api_admin-panel_reports_camp-majors",
        },
      },
      {
        path: "/reports/counselor",
        component: () => import("@/views/reports/counselor"),
        name: "conselorReports",
        meta: {
          permission: "conselorReport_api_admin-panel_reports_teams",
        },
      },
      {
        path: "/reports/director",
        component: () => import("@/views/reports/director"),
        name: "directorReports",
        meta: {
          permission: "directorReport_api_admin-panel_reports_director-report",
        },
      },
      {
        path: "/reports/bus",
        component: () => import("@/views/reports/bus"),
        name: "busReports",
        meta: {
          permission: "busReport_api_admin-panel_reports_bus-report",
        },
      },
      {
        path: "/reports/crm/agents",
        component: () => import("@/views/reports/crm/agents"),
        name: "crmAgentsReports",
        meta: {
          permission: "index_api_admin-panel_reports_finance",
        },
      },
      {
        path: "/reports/crm/interactions",
        component: () => import("@/views/reports/crm/interactions"),
        name: "crmInteractionsReports",
        meta: {
          permission: "index_api_admin-panel_reports_finance",
        },
      },
      {
        path: "/reports/crm/tasks",
        component: () => import("@/views/reports/crm/tasks"),
        name: "crmTasksReports",
        meta: {
          permission: "index_api_admin-panel_reports_finance",
        },
      },
      {
        path: "/reports/sales-and-kpis",
        component: () => import("@/views/reports/salesAndKPIs"),
        name: "salesAndKPIs",
        meta: {
          permission: "index_api_admin-panel_dashboard_crm-kpis",
        },
      },
      {
        path: "/reports/charts",
        component: () => import("@/views/reports/charts"),
        name: "reportsCharts",
        meta: {
          permission: "index_api_admin-panel_reports_finance",
        },
      },
      {
        path: "/reports/on-hand-reports",
        component: () => import("@/views/reports/onHandReports"),
        name: "onHandReport",
        meta: {
          permission: "index_api_admin-panel_reports_abroad",
        },
      },
      {
        path: "/reports/item-control",
        component: () => import("@/views/reports/itemControl"),
        name: "itemControl",
        meta: {
          permission: "index_api_admin-panel_reports_item-control",
        },
      },
      {
        path: "/reports/item-card",
        component: () => import("@/views/reports/itemCard"),
        name: "itemCard",
        meta: {
          permission: "index_api_admin-panel_reports_item-card",
        },
      },
    ],
  },
  {
    path: "/bookings",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/bookings",
        component: () => import("@/views/bookings/index"),
        name: "Bookings",
        meta: {
          permission:
            "index_api_admin-panel_orders_{camp_id?}_{status?}_{gender?}_{month?}_{year?}",
          title: "bookings",
        },
      },
      {
        path: "/reciepts",
        component: () => import("@/views/bookings/reciepts"),
        name: "Reciepts",
        meta: {
          permission: "index_api_admin-panel_receipts",
          title: "Reciepts",
        },
      },
      {
        path: "/bookings/edit/:id",
        component: () => import("@/views/bookings/edit"),
        name: "bookingEdit",
        meta: {
          permission: "update_api_admin-panel_orders",
          title: "bookingEdit",
        },
      },
      {
        path: "/bookings/reservations/:id",
        component: () => import("@/views/bookings/reservations"),
        name: "reservationsEdit",
        meta: {
          permission: "update_api_admin-panel_reservations",
          title: "reservationsEdit",
        },
      },
      {
        path: "/bookings/pay",
        component: () => import("@/views/bookings/pay"),
        name: "pay",
        meta: {
          permission: "pay_api_admin-panel_orders_pay",
          title: "payment",
        },
        props: payment,
      },
    ],
  },
  {
    path: "/accounts",
    component: Layout,
    redirect: "/accounts",
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/accounts",
        component: () => import("@/views/accounts"),
        name: "Accounts",
        meta: {
          permission: "index_api_admin-panel_accounts",
          title: "accounts",
        },
      },
      {
        path: "/accounts/create",
        component: () => import("@/views/accounts/create"),
        name: "AccountsCreate",
        meta: {
          permission: "store_api_admin-panel_accounts",
          title: "accountsCreate",
        },
      },
      {
        path: "/accounts/parents",
        component: () => import("@/views/accounts/parents"),
        name: "ParentAccounts",
        meta: {
          permission: "index_api_admin-panel_parents",
          title: "parentAccounts",
        },
      },
    ],
  },
  {
    path: "/parents",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/accounts/parents/create",
        component: () => import("@/views/accounts/parents/create"),
        name: "ParentCreate",
        meta: {
          permission: "store_api_admin-panel_parents",
        },
      },
      {
        path: "/accounts/parents/create/:id",
        component: () => import("@/views/accounts/parents/create"),
        name: "ParentEdit",
        meta: {
          permission: "update_api_admin-panel_parents_{parent}",
        },
      },
    ],
  },
  {
    path: "/children",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/children",
        component: () => import("@/views/accounts/children"),
        name: "Children",
        meta: {
          permission: "index_api_admin-panel_children",
        },
      },
      {
        path: "/accounts/children/create",
        component: () => import("@/views/accounts/children/create"),
        name: "ChildrenAccounts",
        meta: {
          permission: "store_api_admin-panel_children",
        },
      },
      {
        path: "/accounts/children/create/:id",
        component: () => import("@/views/accounts/children/create"),
        name: "ChildEdit",
        meta: {
          permission: "update_api_admin-panel_children_{child}",
        },
      },
    ],
  },
  {
    path: "/content/news",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/content/news",
        component: () => import("@/views/content/news"),
        name: "News",
        meta: {
          permission: "index_api_admin-panel_content_newsletters",
        },
      },
      {
        path: "/content/news/create",
        component: () => import("@/views/content/news/create"),
        name: "newsCreate",
        meta: {
          permission: "store_api_admin-panel_content_newsletters",
        },
      },
      {
        path: "/content/news/edit/:id",
        component: () => import("@/views/content/news/create"),
        name: "editNews",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_content_newsletters_{newsletter}",
        },
      },
    ],
  },
  {
    path: "/content/sponsors",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/content/sponsors",
        component: () => import("@/views/content/sponsors"),
        name: "sponsors",
        meta: {
          permission: "index_api_admin-panel_content_newsletters",
        },
      },
      {
        path: "/content/sponsors/create",
        component: () => import("@/views/content/sponsors/create"),
        name: "sponsorsCreate",
        meta: {
          permission: "store_api_admin-panel_content_newsletters",
        },
      },
      {
        path: "/content/sponsors/edit/:id",
        component: () => import("@/views/content/sponsors/create"),
        name: "editSponsors",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_content_newsletters_{newsletter}",
        },
      },
    ],
  },
  {
    path: "/content/testimonials",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/content/testimonials",
        component: () => import("@/views/content/testimonials"),
        name: "testimonials",
        meta: {
          permission: "index_api_admin-panel_content_newsletters",
        },
      },
      {
        path: "/content/testimonials/create",
        component: () => import("@/views/content/testimonials/create"),
        name: "testimonialsCreate",
        meta: {
          permission: "store_api_admin-panel_content_newsletters",
        },
      },
      {
        path: "/content/testimonials/edit/:id",
        component: () => import("@/views/content/testimonials/create"),
        name: "editTestimonials",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_content_newsletters_{newsletter}",
        },
      },
    ],
  },
  {
    path: "/content/jobs",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/content/jobs",
        component: () => import("@/views/content/jobs"),
        name: "jobs",
        meta: {
          permission: "index_api_admin-panel_content_newsletters",
        },
      },
      {
        path: "/content/jobs/create",
        component: () => import("@/views/content/jobs/create"),
        name: "jobsCreate",
        meta: {
          permission: "store_api_admin-panel_content_newsletters",
        },
      },
      {
        path: "/content/jobs/edit/:id",
        component: () => import("@/views/content/jobs/create"),
        name: "editJobs",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_content_newsletters_{newsletter}",
        },
      },
    ],
  },
  {
    path: "/content/notification",
    component: Layout,
    // beforeEnter: (to, from, next) => {
    //   if (store.getters.permissions.includes(to.meta.permission)) {
    //     next();
    //   } else {
    //     next("/404");
    //   }
    // },
    children: [
      {
        path: "/content/notification",
        component: () => import("@/views/content/notification/index.vue"),
        name: "jobs",
        meta: {
          permission: "index_api_admin-panel_content_newsletters",
        },
      },
    ],
  },
  {
    path: "/content/job-categories",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/content/job-categories",
        component: () => import("@/views/content/job-categories"),
        name: "jobs-categories",
        meta: {
          permission: "index_api_admin-panel_content_newsletters",
        },
      },
      {
        path: "/content/job-categories/create",
        component: () => import("@/views/content/job-categories/create"),
        name: "jobsCategoriesCreate",
        meta: {
          permission: "store_api_admin-panel_content_newsletters",
        },
      },
      {
        path: "/content/job-categories/edit/:id",
        component: () => import("@/views/content/job-categories/create"),
        name: "editJobCategories",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_content_newsletters_{newsletter}",
        },
      },
    ],
  },

  {
    path: "/content/faqs",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/content/faqs",
        component: () => import("@/views/content/faqs"),
        name: "FAQs",
        meta: {
          permission: "index_api_admin-panel_content_faqs",
        },
      },
      {
        path: "/content/faqs/create",
        component: () => import("@/views/content/faqs/create"),
        name: "faqsCreate",
        meta: {
          permission: "store_api_admin-panel_content_faqs",
        },
      },
      {
        path: "/content/faqs/edit/:id",
        component: () => import("@/views/content/faqs/create"),
        name: "editFAQs",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_content_faqs_{faq}",
        },
      },
    ],
  },
  {
    path: "/content/csr",
    component: Layout,
    children: [
      {
        path: "/content/csr",
        component: () => import("@/views/content/csr"),
        name: "csrIndex",
        meta: {
          permission: "index_api_admin-panel_content_csrs",
        },
      },
      {
        path: "/content/csr/create",
        component: () => import("@/views/content/csr/create"),
        name: "csrCreate",
        meta: {
          permission: "store_api_admin-panel_content_csrs",
        },
      },
      {
        path: "/content/csr/edit/:id",
        component: () => import("@/views/content/csr/create"),
        name: "editCsr",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_content_csrs_{csr}",
        },
      },
      {
        path: "/content/csr/:id/logos",
        component: () => import("@/views/content/csr/logos"),
        name: "CsrLogos",
        meta: {
          permission: "index_api_admin-panel_content_csrs_{csr}_csr-logos",
        },
      },
      {
        path: "/content/csr/:id/slider",
        component: () => import("@/views/content/csr/slider"),
        name: "CsrSlider",
        meta: {
          permission: "index_api_admin-panel_content_csrs_{csr}_csr-sliders",
        },
      },
    ],
  },
  {
    path: "/content/familia-episodes",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/content/familia-episodes",
        component: () => import("@/views/content/familia-episodes"),
        name: "familiaEpisods",
        meta: {
          permission: "index_api_admin-panel_content_familia-episodes",
        },
      },
      {
        path: "/content/familia-episodes/create",
        component: () => import("@/views/content/familia-episodes/create"),
        name: "familiaEpisodsCreate",
        meta: {
          permission: "store_api_admin-panel_content_familia-episodes",
        },
      },
      {
        path: "/content/familia-episodes/edit/:id",
        component: () => import("@/views/content/familia-episodes/create"),
        name: "editfamiliaEpisods",
        hidden: true,
        meta: {
          permission:
            "update_api_admin-panel_content_familia-episodes_{familia_episode}",
        },
      },
    ],
  },
  {
    path: "/content/online-courses",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/content/online-courses",
        component: () => import("@/views/content/online-courses"),
        name: "onlineCourses",
        meta: {
          permission: "index_api_admin-panel_content_online-courses",
        },
      },
      {
        path: "/content/online-courses/create",
        component: () => import("@/views/content/online-courses/create"),
        name: "onlineCoursesCreate",
        meta: {
          permission: "store_api_admin-panel_content_online-courses",
        },
      },
      {
        path: "/content/online-courses/edit/:id",
        component: () => import("@/views/content/online-courses/create"),
        name: "editonlineCourses",
        hidden: true,
        meta: {
          permission:
            "update_api_admin-panel_content_online-courses_{online_course}",
        },
      },
    ],
  },
  {
    path: "/content/discounts-categories",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/content/discounts-categories",
        component: () => import("@/views/content/discounts-categories"),
        name: "discountsCategories",
        meta: {
          permission: "index_api_admin-panel_content_discount-categories",
        },
      },
      {
        path: "/content/discounts-categories/create",
        component: () => import("@/views/content/discounts-categories/create"),
        name: "creatediscountsCategory",
        meta: {
          permission: "store_api_admin-panel_content_discount-categories",
        },
      },
      {
        path: "/content/discounts-categories/edit/:id",
        component: () => import("@/views/content/discounts-categories/create"),
        name: "discountsCategoryEdit",
        hidden: true,
        meta: {
          permission:
            "update_api_admin-panel_content_discount-categories_{discount_category}",
        },
      },
      {
        path: "/content/discounts-categories/:id/discounts",
        component: () =>
          import("@/views/content/discounts-categories/discounts"),
        name: "CategoryDiscounts",
        meta: {
          permission:
            "index_api_admin-panel_content_discount-categories_{discount_category}_discounts",
        },
      },
      {
        path: "/content/discounts-categories/:id/discounts/create",
        component: () =>
          import("@/views/content/discounts-categories/discounts/create"),
        name: "CategoryDiscountsCreate",
        meta: {
          permission:
            "store_api_admin-panel_content_discount-categories_{discount_category}_discounts",
        },
      },
      {
        path: "/content/discounts-categories/:id/discounts/edit/:slug",
        component: () =>
          import("@/views/content/discounts-categories/discounts/create"),
        name: "CategoryDiscountsEdit",
        meta: {
          permission:
            "update_api_admin-panel_content_discount-categories_{discount_category}_discounts_{discount}",
        },
      },
    ],
  },
  {
    path: "/discounts",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/discounts",
        component: () => import("@/views/discounts"),
        name: "Discounts",
        meta: {
          permission: "index_api_admin-panel_discounts",
        },
      },
      {
        path: "/discounts/create",
        component: () => import("@/views/discounts/create"),
        name: "DiscountsCreation",
        meta: {
          permission: "store_api_admin-panel_discounts",
        },
      },
      {
        path: "/discounts/edit/:id",
        component: () => import("@/views/discounts/create"),
        name: "editDiscount",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_discounts_{discount}",
        },
      },
    ],
  },
  {
    path: "/list/promocodes",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/list/promocodes",
        component: () => import("@/views/list/promocodes"),
        name: "promocodes",
        meta: {
          permission: "index_api_admin-panel_promo-codes",
        },
      },
      {
        path: "/list/promocodes/create",
        component: () => import("@/views/list/promocodes/create"),
        name: "promocodesCreation",
        meta: {
          permission: "store_api_admin-panel_promo-codes",
        },
      },
      {
        path: "/list/promocodes/edit/:id",
        component: () => import("@/views/list/promocodes/create"),
        name: "promocodesEdit",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_promo-codes_{promo_code}",
        },
      },
    ],
  },
  {
    path: "/majors",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/majors",
        component: () => import("@/views/majors"),
        name: "Majors",
        meta: {
          permission: "index_api_admin-panel_majors",
        },
      },
      {
        path: "/majors/create",
        component: () => import("@/views/majors/create"),
        name: "majorsCreation",
        meta: {
          permission: "store_api_admin-panel_majors",
        },
      },
      {
        path: "/majors/create/:id",
        component: () => import("@/views/majors/create"),
        name: "editMajor",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_majors_{major}",
        },
      },
    ],
  },
  {
    path: "/cashiers",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/cashiers",
        component: () => import("@/views/cashiers"),
        name: "cashiers",
        meta: {
          permission: "index_api_admin-panel_cashiers",
        },
      },
      {
        path: "/cashiers/create",
        component: () => import("@/views/cashiers/create"),
        name: "cashiersCreation",
        meta: {
          permission: "store_api_admin-panel_cashiers",
        },
      },
      {
        path: "/cashiers/create/:id",
        component: () => import("@/views/cashiers/create"),
        name: "editCashier",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_cashiers_{cashier}",
        },
      },
    ],
  },
  {
    path: "/employees",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/employees",
        component: () => import("@/views/employees"),
        name: "employees",
        meta: {
          permission: "index_api_admin-panel_employees",
        },
      },
      {
        path: "/employees/create",
        component: () => import("@/views/employees/create"),
        name: "employeesCreation",
        meta: {
          permission: "store_api_admin-panel_employees",
        },
      },
      {
        path: "/employees/edit/:id",
        component: () => import("@/views/employees/create"),
        name: "editEmployee",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_employees_{employee}",
        },
      },
      // {
      //   path: "/employees/discounts",
      //   component: () => import("@/views/employees/discounts"),
      //   name: "employeesDiscounts",
      //   meta: {
      //     permission: "index_api_admin-panel_employee-discounts"
      //   }
      // },
      // {
      //   path: "/employees/discounts/edit/:id",
      //   component: () => import("@/views/employees/discounts/edit"),
      //   name: "employeesDiscountsEdit",
      //   meta: {
      //     permission:
      //       "update_api_admin-panel_employee-discounts_{employee_discount}"
      //   }
      // }
    ],
  },
  {
    path: "/parameters",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/parameters",
        component: () => import("@/views/parameters"),
        name: "Parameters",
        meta: {
          permission: "index_api_admin-panel_parameters",
        },
      },
    ],
  },
  {
    path: "/bus-locations",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/bus-locations",
        component: () => import("@/views/bus-locations"),
        name: "busLocations",
        meta: {
          permission: "index_api_admin-panel_bus-locations",
        },
      },
      {
        path: "/bus-locations/create",
        component: () => import("@/views/bus-locations/create"),
        name: "busLocationCreation",
        meta: {
          permission: "store_api_admin-panel_bus-locations",
        },
      },
      {
        path: "/bus-locations/edit/:id",
        component: () => import("@/views/bus-locations/create"),
        name: "busLocationEdit",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_bus-locations_{bus_location}",
        },
      },
    ],
  },
  {
    path: "/camp-locations",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/camp-locations",
        component: () => import("@/views/camp-locations"),
        name: "campLocations",
        meta: {
          permission: "index_api_admin-panel_bus-locations",
        },
      },
      {
        path: "/camp-locations/create",
        component: () => import("@/views/camp-locations/create"),
        name: "campLocationCreation",
        meta: {
          permission: "store_api_admin-panel_bus-locations",
        },
      },
      {
        path: "/camp-locations/edit/:id",
        component: () => import("@/views/camp-locations/create"),
        name: "campLocationEdit",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_bus-locations_{bus_location}",
        },
      },
    ],
  },
  {
    path: "/bus-stops",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/bus-stops",
        component: () => import("@/views/bus-stops"),
        name: "busStops",
        meta: {
          permission: "index_api_admin-panel_bus-stops",
        },
      },
      {
        path: "/bus-stops/create",
        component: () => import("@/views/bus-stops/create"),
        name: "busStopCreation",
        meta: {
          permission: "store_api_admin-panel_bus-stops",
        },
      },
      {
        path: "/bus-stops/edit/:id",
        component: () => import("@/views/bus-stops/create"),
        name: "busStopEdit",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_bus-stops_{bus_stop}",
        },
      },
    ],
  },
  {
    path: "/hr/application-types",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/hr/application-types",
        component: () => import("@/views/hr/application-types"),
        name: "appTypes",
        meta: {
          permission: "index_api_admin-panel_hr_application-types",
        },
      },
      {
        path: "/hr/phases",
        component: () => import("@/views/hr/phases"),
        name: "phases",
        meta: {
          permission: "index_api_admin-panel_hr_phases",
        },
      },
      {
        path: "/hr/dashboard",
        component: () => import("@/views/hr/dashboard"),
        name: "hrDashboard",
        meta: {
          permission:
            "index_api_admin-panel_hr_dashboard_applications" ||
            "index_api_admin-panel_hr_dashboard_statistics",
        },
      },
      {
        path: "/hr/dashboard/filter-application",
        component: () => import("@/views/hr/dashboard/filter-application"),
        name: "hrDashboardFilter",
        meta: {
          permission:
            "index_api_admin-panel_hr_dashboard_applications" ||
            "index_api_admin-panel_hr_dashboard_statistics",
        },
      },
      {
        path: "/hr/dashboard/applicant/:id",
        component: () => import("@/views/hr/dashboard/applicant"),
        name: "dashboardApplicant",
        meta: {
          permission:
            "show_api_admin-panel_hr_dashboard_applications_{application}",
        },
      },
      {
        path: "/hr/phases/create",
        component: () => import("@/views/hr/phases/create"),
        name: "phaseCreation",
        meta: {
          permission: "",
        },
      },
      {
        path: "/hr/phases/edit/:id",
        component: () => import("@/views/hr/phases/create"),
        name: "phasesEdit",
        hidden: true,
        meta: {
          permission: "",
        },
      },
      {
        path: "/hr/phases/questions",
        component: () => import("@/views/hr/phases/questions"),
        name: "phaseQuestions",
        meta: {
          permission: "",
        },
      },
      {
        path: "/hr/phases/questions/create",
        component: () => import("@/views/hr/phases/questions/create"),
        name: "phaseQuestionsCreate",
        meta: {
          permission: "",
        },
      },
      {
        path: "/hr/phases/questions/edit/:id",
        component: () => import("@/views/hr/phases/questions/create"),
        name: "phaseQuestionsEdit",
        meta: {
          permission: "",
        },
      },
      {
        path: "/hr/phases/questions/choices",
        component: () => import("@/views/hr/phases/questions/choices"),
        name: "phaseQuestionsChoices",
        meta: {
          permission: "",
        },
      },
      {
        path: "/hr/phases/questions/choices/create",
        component: () => import("@/views/hr/phases/questions/choices/create"),
        name: "choiceCreate",
        meta: {
          permission: "",
        },
      },
      {
        path: "/hr/phases/questions/choices/edit/:id",
        component: () => import("@/views/hr/phases/questions/choices/create"),
        name: "choiceEdit",
        meta: {
          permission: "",
        },
      },
      {
        path: "/hr/collection-bags",
        component: () => import("@/views/hr/collection-bags"),
        name: "collectionBags",
        meta: {
          permission: "index_api_admin-panel_hr_collection-bags",
        },
      },
      {
        path: "/hr/collection-bags/create",
        component: () => import("@/views/hr/collection-bags/create"),
        name: "collectionBagsCreate",
        meta: {
          permission: "",
        },
      },
      {
        path: "/hr/collection-bags/edit/:id",
        component: () => import("@/views/hr/collection-bags/create"),
        name: "collectionBagsEdit",
        meta: {
          permission: "",
        },
      },
      {
        path: "/hr/collection-bags/sources",
        component: () => import("@/views/hr/collection-bags/sources"),
        name: "bagSources",
        meta: {
          permission: "",
        },
      },
      {
        path: "/hr/collection-bags/sources/create",
        component: () => import("@/views/hr/collection-bags/sources/create"),
        name: "bagSourcesCreate",
        meta: {
          permission: "",
        },
      },
      {
        path: "/hr/collection-bags/sources/edit/:id",
        component: () => import("@/views/hr/collection-bags/sources/create"),
        name: "bagSourcesEdit",
        meta: {
          permission: "",
        },
      },
    ],
  },
  {
    path: "/camp-types",
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/camp-types",
        component: () => import("@/views/camp-types"),
        name: "campTypes",
        meta: {
          permission: "index_api_admin-panel_camp-types",
        },
      },
      {
        path: "/camp-types/create",
        component: () => import("@/views/camp-types/create"),
        name: "createCampType",
        meta: {
          permission: "store_api_admin-panel_camp-types",
        },
      },
      {
        path: "/camp-types/edit/:id",
        component: () => import("@/views/camp-types/create"),
        name: "campTypeEdit",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_camp-types_{camp_type}",
        },
      },
      {
        path: "/camp-types/:id/sub-types",
        component: () => import("@/views/camp-types/sub-types"),
        name: "CampsSubTypes",
        meta: {
          permission: "index_api_admin-panel_camp-types_{camp_type}_sub-types",
        },
      },
      {
        path: "/camp-types/:id/sub-types/create",
        component: () => import("@/views/camp-types/sub-types/create"),
        name: "CampsSubTypesCreate",
        meta: {
          permission: "store_api_admin-panel_camp-types_{camp_type}_sub-types",
        },
      },
      {
        path: "/camp-types/:id/sub-types/edit/:slug",
        component: () => import("@/views/camp-types/sub-types/create"),
        name: "CampsSubTypesEdit",
        meta: {
          permission:
            "update_api_admin-panel_camp-types_{camp_type}_sub-types_{sub_type}",
        },
      },
      {
        path: "/camp-types/:id/sub-types/:slug/schedules",
        component: () => import("@/views/camp-types/sub-types/schedules"),
        name: "CampsSubTypesSchedules",
        meta: {
          permission:
            "index_api_admin-panel_camp-types_{camp_type}_sub-types_{sub_type}_schedules",
        },
      },
      {
        path: "/camp-types/:id/sub-types/:slug/schedules/:index/details",
        component: () =>
          import("@/views/camp-types/sub-types/schedules/details"),
        name: "CampsSubTypesSchedulesDetails",
        meta: {
          permission:
            "index_api_admin-panel_camp-types_{camp_type}_sub-types_{sub_type}_schedules_{schedule}_details",
        },
      },
      {
        path: "/camp-types/:id/sub-types/:slug/schedules/:index/details/create",
        component: () =>
          import("@/views/camp-types/sub-types/schedules/details/create"),
        name: "CampsSubTypesSchedulesDetailsCreate",
        meta: {
          permission:
            "store_api_admin-panel_camp-types_{camp_type}_sub-types_{sub_type}_schedules_{schedule}_details",
        },
      },
      {
        path:
          "/camp-types/:id/sub-types/:slug/schedules/:index/details/edit/:detail",
        component: () =>
          import("@/views/camp-types/sub-types/schedules/details/create"),
        name: "CampsSubTypesSchedulesDetailsEdit",
        meta: {
          permission:
            "update_api_admin-panel_camp-types_{camp_type}_sub-types_{sub_type}_schedules_{schedule}_details_{detail}",
        },
      },
      {
        path: "/camp-types/:id/sub-types/:slug/schedules/create",
        component: () =>
          import("@/views/camp-types/sub-types/schedules/create"),
        name: "CampsSubTypesSchedulesCreate",
        meta: {
          permission:
            "store_api_admin-panel_camp-types_{camp_type}_sub-types_{sub_type}_schedules",
        },
      },
      {
        path: "/camp-types/:id/sub-types/:slug/schedules/edit/:index",
        component: () =>
          import("@/views/camp-types/sub-types/schedules/create"),
        name: "CampsSubTypesSchedulesEdit",
        meta: {
          permission:
            "update_api_admin-panel_camp-types_{camp_type}_sub-types_{sub_type}_schedules_{schedule}",
        },
      },
      {
        path: "/camp-types/:id/sub-types/:slug/activities",
        component: () => import("@/views/camp-types/sub-types/activities"),
        name: "CampsSubTypesActivities",
        meta: {
          permission:
            "index_api_admin-panel_camp-types_{camp_type}_sub-types_{sub_type}_activities",
        },
      },
      {
        path: "/camp-types/:id/sub-types/:slug/activities/create",
        component: () =>
          import("@/views/camp-types/sub-types/activities/create"),
        name: "CampsSubTypesActivitiesCreate",
        meta: {
          permission:
            "store_api_admin-panel_camp-types_{camp_type}_sub-types_{sub_type}_activities",
        },
      },
      {
        path: "/camp-types/:id/sub-types/:slug/activities/edit/:index",
        component: () =>
          import("@/views/camp-types/sub-types/activities/create"),
        name: "CampsSubTypesActivitiesEdit",
        meta: {
          permission:
            "update_api_admin-panel_camp-types_{camp_type}_sub-types_{sub_type}_activities_{activity}",
        },
      },
    ],
  },
  {
    path: "/scm",
    component: Layout,
    redirect: "/scm/items",
    beforeEnter: (to, from, next) => {
      if (store.getters.permissions.includes(to.meta.permission)) {
        next();
      } else {
        next("/404");
      }
    },
    children: [
      {
        path: "/scm/items",
        component: () => import("@/views/scm/items/index"),
        name: "scmItems",
        meta: {
          permission: "index_api_admin-panel_scm_items",
        },
      },
      {
        path: "/scm/items/add",
        component: () => import("@/views/scm/items/crud"),
        name: "itemsCreate",
        meta: {
          permission: "store_api_admin-panel_scm_items",
        },
      },
      {
        path: "/scm/items/edit/:id",
        component: () => import("@/views/scm/items/crud"),
        name: "edititems",
        hidden: true,
        meta: {
          permission: "update_api_admin-panel_scm_items_{item}",
        },
      },
      {
        path: "/scm/categories",
        component: () => import("@/views/scm/categories/index"),
        name: "scmCategories",
        meta: {
          permission: "index_api_admin-panel_scm_categories",
        },
      },
      {
        path: "/scm/:categoryId/sub-categories",
        component: () => import("@/views/scm/subCategories/index"),
        name: "scmSubCategories",
        meta: {
          permission: "index_api_admin-panel_scm_sub-categories",
        },
      },
      {
        path: "/scm/transactions-types",
        component: () => import("@/views/scm/transactionsTypes/index"),
        name: "scmTransactionsTypes",
        meta: {
          permission: "index_api_admin-panel_scm_transaction-types",
        },
      },
      {
        path: "/scm/sub-inventories",
        component: () => import("@/views/scm/subInventories/index"),
        name: "scmSubInventories",
        meta: {
          permission: "index_api_admin-panel_scm_inventories",
        },
      },
      {
        path: "/scm/transactions",
        component: () => import("@/views/scm/transactions/index"),
        name: "scmTransactions",
        meta: {
          permission: "index_api_admin-panel_scm_transactions",
        },
      },
      {
        path: "/scm/bulk-transactions",
        component: () => import("@/views/scm/bulkTransaction"),
        name: "scmBulkTransaction",
        meta: {
          permission: "index_api_admin-panel_scm_transactions",
        },
      },
      {
        path: "/scm/on-hands",
        component: () => import("@/views/scm/onHands/index"),
        name: "scmOnHands",
        meta: {
          permission: "index_api_admin-panel_scm_on-hands",
        },
      },
      {
        path: "/scm/camps",
        component: () => import("@/views/scm/camps"),
        name: "scmCamps",
        meta: {
          permission: "index_api_admin-panel_scm_camps",
        },
      },
      {
        path: "/scm/camps/create",
        component: () => import("@/views/scm/camps/create"),
        name: "scmCampsCreate",
        meta: {
          permission: "store_api_admin-panel_scm_camps",
        },
      },
      {
        path: "/scm/camps/edit/:id",
        component: () => import("@/views/scm/camps/create"),
        name: "scmCampsEdit",
        meta: {
          permission: "update_api_admin-panel_scm_camps_{camp}",
        },
      },
      {
        path: "/scm/employees",
        component: () => import("@/views/scm/employees"),
        name: "scmEmployees",
        meta: {
          permission: "index_api_admin-panel_scm_employees",
        },
      },
      {
        path: "/scm/employees/create",
        component: () => import("@/views/scm/employees/create"),
        name: "scmEmployeesCreate",
        meta: {
          permission: "store_api_admin-panel_scm_employees",
        },
      },
      {
        path: "/scm/employees/edit/:id",
        component: () => import("@/views/scm/employees/create"),
        name: "scmEmployeesEdit",
        meta: {
          permission: "update_api_admin-panel_scm_employees_{employee}",
        },
      },
    ],
  },
  { path: "*", redirect: "/404", hidden: true },
];
